module.exports = __webpack_public_path__ + "img/17-develop.ee066d30.jpg";